import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default function CustomeCarousel({ images }) {

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <div>
      <Carousel infinite={true} autoPlay={true} responsive={responsive}>
        {images.map((image, index) => (
          <div
            key={index}
            style={{ height: "100%", width: "100%", overflow: "hidden" }}>
            <img
              src={image.url}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              alt={`Image ${index + 1}`}
            />
          </div>
        ))}
      </Carousel>
    </div>
  )
}
